export function Icon({
  name: icon,
  size = 20,
  className = '',
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  const aliases: Record<string, string> = {
    InfoOutline: 'Info',
    Settings: 'Controls',
    ArrowDown: 'ChevronDown',
    ArrowUp: 'ArrowThinUp',
    '16/ColumnSettings': 'Controls',
  };
  icon = aliases[icon] || icon;
  return (
    <span
      aria-hidden="true"
      className={`icon ${className}`}
      style={{
        width: size,
        height: size,
        maskImage: `url(/assets/${icon}.svg)`,
        WebkitMaskImage: `url(/assets/${icon}.svg)`,
      }}
    />
  );
}
